import { Search, Filter } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { AllFreelancerProps } from "@/store/freelancerStore";
import { CATEGORIES, Skills } from "@/utils/constant";

interface FreelancerFiltersProps {
  fetchDataProps: AllFreelancerProps;
  setFetchDataProps: (data: AllFreelancerProps) => void;
  debouncedFetchJobs: (searchTerm: string) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedSkills: string[];
  setSelectedSkills: (skills: string[]) => void;
  availabilityFilter: string;
  setAvailabilityFilter: (availability: string) => void;
  rateRange: string;
  setRateRange: (range: string) => void;
  rating: string;
  setRating: (rating: string) => void;
  getAllFreelancers: (data: any) => void;
}

export const FreelancerFilters = ({
  searchTerm,
  setSearchTerm,
  fetchDataProps,
  setFetchDataProps,
  debouncedFetchJobs,
  selectedSkills,
  setSelectedSkills,
  availabilityFilter,
  setAvailabilityFilter,
  rateRange,
  setRateRange,
  getAllFreelancers,
  rating,
  setRating
}: FreelancerFiltersProps) => {
  return (
    <div className="space-y-4 bg-white p-6 rounded-lg shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {/* <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <Input
            className="pl-10"
            placeholder="Search freelancers..."
            value={fetchDataProps?.search}
            onChange={(e) => {
              const searchTerm = e.target.value;
              debouncedFetchJobs(searchTerm);
              setFetchDataProps({
                ...fetchDataProps,
                search: searchTerm,
              });
            }}
          />
        </div> */}

        <Select
          value={
            fetchDataProps.availability === undefined
              ? ""
              : String(fetchDataProps.availability)
          }
          onValueChange={(value) => {
            setFetchDataProps({
              ...fetchDataProps,
              availability: value === "" ? undefined : value === "true",
              page: 1,
            });
            getAllFreelancers({ ...fetchDataProps, availability: value === "" ? undefined : value === "true" })
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Availability" />
          </SelectTrigger>
          <SelectContent>
            {/* <SelectItem value="">All Availability</SelectItem> */}
            <SelectItem value="true">Available Now</SelectItem>
            <SelectItem value="false">Not Available</SelectItem>
            {/* <SelectItem value="next-week">Next Week</SelectItem>
            <SelectItem value="next-month">Next Month</SelectItem> */}
          </SelectContent>
        </Select>

        <Select
          value={fetchDataProps.dailyRate}
          onValueChange={(value) => {
            setFetchDataProps({
              ...fetchDataProps,
              dailyRate: value,
              page: 1,
            });
            getAllFreelancers({ ...fetchDataProps, dailyRate: value })
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Daily Rate" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Rates</SelectItem>
            <SelectItem value="0-25">$0 - $25</SelectItem>
            <SelectItem value="25-50">$25 - $50</SelectItem>
            <SelectItem value="50-100">$50 - $100</SelectItem>
            <SelectItem value="100+">$100+</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={fetchDataProps.category}
          onValueChange={(value) => {
            setFetchDataProps({
              ...fetchDataProps,
              category: value === "all" ? "" : value,
              page: 1,
            });
            getAllFreelancers({ ...fetchDataProps, category: value === "all" ? "" : value })
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={"all"}>All</SelectItem>
            {CATEGORIES.map((category, idx) => {
              return (
                <div key={idx}>
                  <SelectItem value={category}>{category}</SelectItem>
                </div>
              );
            })}
          </SelectContent>
        </Select>

        <div>
          <Select
            value={fetchDataProps.skills}
            onValueChange={(value) => {
              setFetchDataProps({
                ...fetchDataProps,
                skills: value === "all" ? "" : value,
                page: 1,
              });
              getAllFreelancers({ ...fetchDataProps, skills: value === "all" ? "" : value })
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Skills" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {Skills.map((skill, idx) => {
                return (
                  <SelectItem key={idx} value={skill}>
                    {skill}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Select
            value={rating}
            onValueChange={(value) => {
              setRating(value);

              const sortProps =
                value === "all"
                  ? { rating: ""}
                  : {
                    rating: value === "highest" ? "desc" : "asc",
                  };

              setFetchDataProps({
                ...fetchDataProps,
                ...sortProps,
                page: 1,
              });

              getAllFreelancers({
                ...fetchDataProps,
                ...sortProps,
                page: 1,
              });
            }}
          >
            <SelectTrigger>
              <SelectValue>
                {rating === "all" ? "Rating" : rating === "highest" ? "Highest Rating" : "Lowest Rating"}
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Default</SelectItem>
              <SelectItem value="highest">Highest Rating</SelectItem>
              <SelectItem value="lowest">Lowest Rating</SelectItem>
            </SelectContent>
          </Select>
        </div>


        {/* <Select
          value={selectedSkills[0] || "all"}
          onValueChange={(value) => setSelectedSkills([value])}
        >
          <SelectTrigger>
            <SelectValue placeholder="Skills" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Skills</SelectItem>
            <SelectItem value="React">React</SelectItem>
            <SelectItem value="Node.js">Node.js</SelectItem>
            <SelectItem value="TypeScript">TypeScript</SelectItem>
            <SelectItem value="Python">Python</SelectItem>
            <SelectItem value="AWS">AWS</SelectItem>
            <SelectItem value="Docker">Docker</SelectItem>
            <SelectItem value="UI/UX">UI/UX Design</SelectItem>
          </SelectContent>
        </Select> */}
      </div>

      <div className="flex items-center gap-2 text-sm text-gray-600">
        <Filter className="h-4 w-4" />
        <span>Showing filtered results based on your preferences</span>
      </div>
    </div>
  );
};
